import React from 'react';
import {Snackbar} from "@mui/material";
import Alert from '@mui/material/Alert';

const CustomSnackbar = ({ open, onClose, severity, message, anchorOrigin }) => {
  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    onClose();
  };

  return (
    <Snackbar open={open} autoHideDuration={6000} onClose={handleClose} anchorOrigin={anchorOrigin}>
      <Alert elevation={6} variant="filled" onClose={handleClose} severity={severity}>
            {message}
      </Alert>
    </Snackbar>
  );
};

export default CustomSnackbar;